@if (data.title) {
  <div style="font-size: 20px; text-align: center; padding: 15px 0 25px; ">
    <div style="font-weight: bold">{{ data.title | translate }}</div>
    <small style="font-weight: 500;">{{ data.subTitle | translate }}</small>
  </div>
  <mat-divider></mat-divider>
}
<div class="generic-list">
  @for (act of data.actions; track act; let i = $index) {
    @if (i > 0) {
      <mat-divider></mat-divider>
    }
    <div class="generic-list-item" style="padding: 0 1rem" (click)="openLink(act, $event)">
      <img class="_avatar" [src]="act.image"/>
      <div class="_content">
        <div class="_title">{{ act.text | translate }}</div>
        <div class="_line">{{ act.description | translate }}</div>
      </div>
    </div>
  }
</div>
<div class="mb-3">
  <mat-divider></mat-divider>
  <app-power-by-tabit></app-power-by-tabit>
</div>
